import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { value: '50+',    label: 'Projects Completed' },
  { value: '99.99%', label: 'Uptime Guaranteed' },
  { value: '10×',    label: 'Faster AI Systems' },
  { value: '∞',      label: 'Scalable Infrastructure' },
  { value: '$0',     label: 'Security Breaches' },
  { value: '24/7',   label: 'Engineering Support' },
];

const marqueeItems = [
  'SaaS Architecture', 'AI Systems', 'RAG Pipelines', 'API Engineering',
  'Cloud Infrastructure', 'Mobile Apps', 'Automation', 'Enterprise APIs',
  'Neural Networks', 'Data Platforms',
];

const Stats = () => {
  return (
    <>
      {/* ─── Marquee ticker ─── */}
      <div style={{
        background: '#000',
        padding: '20px 0',
        overflow: 'hidden',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}>
        <motion.div
          style={{ display: 'flex', gap: '0', whiteSpace: 'nowrap' }}
          animate={{ x: ['0%', '-50%'] }}
          transition={{ repeat: Infinity, duration: 30, ease: 'linear' }}
        >
          {[...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems].map((item, i) => (
            <span key={i} style={{
              fontSize: '12px',
              fontWeight: 600,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.35)',
              flexShrink: 0,
              padding: '0 32px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '32px',
            }}>
              {item}
              <span style={{
                width: '3px', height: '3px', borderRadius: '50%',
                background: 'rgba(255,255,255,0.2)', display: 'inline-block', flexShrink: 0,
              }} />
            </span>
          ))}
        </motion.div>
      </div>

      {/* ─── Stats grid ─── */}
      <section style={{ background: 'transparent', padding: '40px 0' }}>
        <div style={{
          maxWidth: '1320px', margin: '0 auto',
          padding: '0 clamp(20px, 4vw, 40px)',
        }}>
          {/* Desktop: 3-col grid | Tablet: 2-col | Mobile: 1-col — via inline media via JS */}
          <StatsGrid />
        </div>
      </section>
    </>
  );
};

/* Responsive grid using ResizeObserver */
const StatsGrid = () => {
  const [cols, setCols] = React.useState(3);

  React.useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 480) setCols(1);
      else if (w < 860) setCols(2);
      else setCols(3);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${cols}, 1fr)`,
      gap: '1px',
      background: 'var(--glass-border)',
      borderRadius: '24px',
      overflow: 'hidden',
    }}>
      {stats.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: 0.07 * i, ease: [0.16, 1, 0.3, 1] }}
          style={{
            background: 'var(--glass-bg)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            padding: cols === 1 ? '32px 24px' : '44px 24px',
            textAlign: 'center',
            minWidth: 0, /* prevent overflow */
          }}
        >
          <div style={{
            fontSize: cols === 1 ? 'clamp(36px, 10vw, 52px)' : 'clamp(28px, 4.5vw, 56px)',
            fontWeight: 900,
            letterSpacing: '-0.04em',
            color: 'var(--ink)',
            marginBottom: '8px',
            lineHeight: 1,
            wordBreak: 'break-word',
          }}>
            {s.value}
          </div>
          <div style={{
            fontSize: '11px',
            fontWeight: 600,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: 'var(--ink-3)',
            lineHeight: 1.4,
          }}>
            {s.label}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default Stats;
